import React from 'react';
import * as Containers from './uninstallCommonComponents';
import { UninstallForm } from './uninstallForm';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { getQueryParameterByName } from '../../common/utilities/queryParameters';
const wwwweatherbugcom = 'www.WeatherBug.com';
let appInstanceId = getQueryParameterByName('appInstanceId') || '';
let appVersion = getQueryParameterByName('appVersion') || '';
let appId = getQueryParameterByName('appId');
let appName = getQueryParameterByName('appName');
// TECHDEBT:
// 1) not sure this works as-is, as we were getting weird global
// redirects no matter what page we loaded
// 2) but we probably need a redirect
// in case there are some missing parameters on the way in
// if (!appInstanceId || !appVersion || !appId) {
//     window.location.replace("http://www.weatherbug.com");
// }
let supportEmail = 'chromeextensionsupport@weatherbug.com';
let mailTo = 'mailto:chromeextensionsupport@weatherbug.com';
if (window.location.pathname.includes('d11')) {
    supportEmail = 'windowsdesktopsupport@weatherbug.com';
    mailTo = 'mailto:windowsdesktopsupport@weatherbug.com';
}
export const UninstallAppScreen = withScreenSize(({ isDesktop }) => {
    return(
        <Containers.RemoveBackgroundAddMenu>
            <Containers.Main>
                <Containers.MainContainer>
                    <Containers.ContentRow>
                        <UninstallForm
                            supportEmail={supportEmail}
                            appInstanceId={appInstanceId}
                            appVersion={appVersion}
                            appId={appId}
                            appName={appName}
                        />
                        <Containers.Link href={mailTo} rel='noopener noreferrer'>
                            <img alt='Support email' src='./images/icons/outline-email-24px.svg'/>
                            {supportEmail}
                        </Containers.Link>
                        <Containers.Link href='https://www.weatherbug.com' target='_blank' rel='noopener noreferrer'>
                            <img alt='' src='./images/icons/outline-web-24px.svg'/>
                            {wwwweatherbugcom}
                        </Containers.Link>
                    </Containers.ContentRow>
                    { isDesktop
                        && <Containers.ContentRowRight />
                    }
                </Containers.MainContainer>
            </Containers.Main>
        </Containers.RemoveBackgroundAddMenu>
    );
});

UninstallAppScreen.DisplayName = 'PartnersScreen';
